import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type{ CSSProperties } from 'react'

const descriptionWrapper: CSSProperties = {
  textAlign: 'center',
  paddingBottom: '8px'
}

const TestConfigOutdated = () =>
  <Paragraph>
    <Color variant='greyB'>
      <span style={descriptionWrapper}>
        This panel contains stale data resulting from a change in your model
        <br />
        parameter settings, scripts, or test case step sequences. Please refresh
        <br />
        this panel, reassign custom values, and save.
      </span>
    </Color>
  </Paragraph>

export default TestConfigOutdated
